function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M129.003 59.4765C129.728 59.4765 130.316 58.8886 130.316 58.1633C130.316 57.438 129.728 56.8501 129.003 56.8501C128.277 56.8501 127.689 57.438 127.689 58.1633C127.689 58.8886 128.277 59.4765 129.003 59.4765Z",
  fill: "#C7F8FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4513 105.69C29.4513 106.376 29.248 107.046 28.867 107.617C28.4861 108.187 27.9446 108.631 27.3112 108.893C26.6777 109.156 25.9806 109.225 25.3081 109.091C24.6356 108.957 24.0178 108.627 23.533 108.142C23.0482 107.657 22.718 107.039 22.5842 106.367C22.4504 105.694 22.5191 104.997 22.7815 104.364C23.0439 103.73 23.4882 103.189 24.0584 102.808C24.6285 102.427 25.2988 102.224 25.9844 102.224C26.9039 102.224 27.7857 102.589 28.4359 103.239C29.086 103.889 29.4513 104.771 29.4513 105.69Z",
  fill: "#C7F8FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5999 93.5868C38.659 89.0854 35.8685 84.5778 31.3671 83.5187C26.8658 82.4596 22.3581 85.2501 21.299 89.7514C20.2399 94.2528 23.0304 98.7604 27.5318 99.8195C32.0331 100.879 36.5408 98.0881 37.5999 93.5868Z",
  fill: "#C7F8FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M164.59 156.305C167.86 153.035 167.86 147.734 164.59 144.464C161.321 141.194 156.019 141.194 152.749 144.464C149.479 147.734 149.479 153.035 152.749 156.305C156.019 159.575 161.321 159.575 164.59 156.305Z",
  fill: "#C7F8FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M160.982 137.302C160.982 137.759 160.846 138.206 160.592 138.586C160.338 138.966 159.977 139.262 159.555 139.437C159.133 139.612 158.668 139.658 158.22 139.569C157.771 139.48 157.36 139.26 157.036 138.936C156.713 138.613 156.493 138.201 156.404 137.753C156.315 137.305 156.36 136.84 156.535 136.418C156.71 135.995 157.006 135.634 157.387 135.38C157.767 135.126 158.213 134.991 158.671 134.991C158.975 134.989 159.276 135.048 159.557 135.164C159.838 135.28 160.093 135.45 160.308 135.665C160.523 135.879 160.693 136.135 160.809 136.416C160.924 136.697 160.983 136.998 160.982 137.302Z",
  fill: "#C7F8FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M136.735 63.3425C136.735 63.8001 136.599 64.2473 136.345 64.6277C136.09 65.008 135.729 65.3042 135.306 65.4788C134.883 65.6534 134.417 65.6986 133.969 65.6085C133.52 65.5185 133.108 65.2973 132.786 64.9731C132.463 64.6488 132.243 64.236 132.155 63.7869C132.067 63.3379 132.115 62.8729 132.291 62.4507C132.468 62.0286 132.766 61.6684 133.147 61.4157C133.529 61.163 133.976 61.0292 134.434 61.0313C134.737 61.0313 135.037 61.0911 135.317 61.2074C135.597 61.3237 135.851 61.4941 136.065 61.7089C136.278 61.9236 136.448 62.1785 136.563 62.4588C136.678 62.7392 136.736 63.0395 136.735 63.3425Z",
  fill: "#C7F8FF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6506 100.039C14.3759 100.039 14.9638 99.4506 14.9638 98.7253C14.9638 98.0001 14.3759 97.4121 13.6506 97.4121C12.9253 97.4121 12.3374 98.0001 12.3374 98.7253C12.3374 99.4506 12.9253 100.039 13.6506 100.039Z",
  fill: "#C7F8FF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M155.76 167.296C156.486 167.296 157.074 166.708 157.074 165.983C157.074 165.257 156.486 164.669 155.76 164.669C155.035 164.669 154.447 165.257 154.447 165.983C154.447 166.708 155.035 167.296 155.76 167.296Z",
  fill: "#C7F8FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M155.235 185.754C152.378 194.39 144.015 201.281 135.275 205.042C120.273 211.514 103.285 211.934 87.0642 209.886C67.7864 207.459 48.7292 201.576 32.4349 190.975C24.7553 185.954 17.4959 179.661 13.4092 171.393C8.61863 161.686 8.70267 150.066 11.9279 139.729C15.1531 129.391 21.2989 120.199 28.2116 111.868C32.8972 106.216 38.1605 100.574 39.9044 93.441C41.8375 85.5197 39.085 77.3043 38.3181 69.1835C37.3936 59.4447 39.2005 45.5773 45.672 37.7401C52.4587 29.5142 67.1666 24.8076 77.357 24.0827C89.4911 23.1898 102.213 27.4445 110.376 36.4584C119.674 46.7224 122.983 62.4809 135.022 69.3936C141.452 73.1021 149.342 73.5328 155.834 77.1362C165.289 82.3891 170.206 93.9453 169.492 104.808C168.777 115.671 163.104 125.651 155.834 133.699C152.977 136.85 149.762 139.918 148.302 143.921C146.201 149.594 148.102 155.908 150.539 161.444C152.977 166.98 156.013 172.464 156.307 178.495C156.397 180.96 156.034 183.42 155.235 185.754Z",
  fill: "#D0EEF9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M129.003 59.4765C129.728 59.4765 130.316 58.8886 130.316 58.1633C130.316 57.438 129.728 56.8501 129.003 56.8501C128.277 56.8501 127.689 57.438 127.689 58.1633C127.689 58.8886 128.277 59.4765 129.003 59.4765Z",
  fill: "#C7F8FF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4513 105.69C29.4513 106.376 29.248 107.046 28.867 107.617C28.4861 108.187 27.9446 108.631 27.3112 108.893C26.6777 109.156 25.9806 109.225 25.3081 109.091C24.6356 108.957 24.0178 108.627 23.533 108.142C23.0482 107.657 22.718 107.039 22.5842 106.367C22.4504 105.694 22.5191 104.997 22.7815 104.364C23.0439 103.73 23.4882 103.189 24.0584 102.808C24.6285 102.427 25.2988 102.224 25.9844 102.224C26.9039 102.224 27.7857 102.589 28.4359 103.239C29.086 103.889 29.4513 104.771 29.4513 105.69Z",
  fill: "#C7F8FF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5999 93.5868C38.659 89.0854 35.8685 84.5778 31.3671 83.5187C26.8658 82.4596 22.3581 85.2501 21.299 89.7514C20.2399 94.2528 23.0304 98.7604 27.5318 99.8195C32.0331 100.879 36.5408 98.0881 37.5999 93.5868Z",
  fill: "#C7F8FF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M164.59 156.305C167.86 153.035 167.86 147.734 164.59 144.464C161.321 141.194 156.019 141.194 152.749 144.464C149.479 147.734 149.479 153.035 152.749 156.305C156.019 159.575 161.321 159.575 164.59 156.305Z",
  fill: "#C7F8FF"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M160.982 137.302C160.982 137.759 160.846 138.206 160.592 138.586C160.338 138.966 159.977 139.262 159.555 139.437C159.133 139.612 158.668 139.658 158.22 139.569C157.771 139.48 157.36 139.26 157.036 138.936C156.713 138.613 156.493 138.201 156.404 137.753C156.315 137.305 156.36 136.84 156.535 136.418C156.71 135.995 157.006 135.634 157.387 135.38C157.767 135.126 158.213 134.991 158.671 134.991C158.975 134.989 159.276 135.048 159.557 135.164C159.838 135.28 160.093 135.45 160.308 135.665C160.523 135.879 160.693 136.135 160.809 136.416C160.924 136.697 160.983 136.998 160.982 137.302Z",
  fill: "#C7F8FF"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M136.735 63.3425C136.735 63.8001 136.599 64.2473 136.345 64.6277C136.09 65.008 135.729 65.3042 135.306 65.4788C134.883 65.6534 134.417 65.6986 133.969 65.6085C133.52 65.5185 133.108 65.2973 132.786 64.9731C132.463 64.6488 132.243 64.236 132.155 63.7869C132.067 63.3379 132.115 62.8729 132.291 62.4507C132.468 62.0286 132.766 61.6684 133.147 61.4157C133.529 61.163 133.976 61.0292 134.434 61.0313C134.737 61.0313 135.037 61.0911 135.317 61.2074C135.597 61.3237 135.851 61.4941 136.065 61.7089C136.278 61.9236 136.448 62.1785 136.563 62.4588C136.678 62.7392 136.736 63.0395 136.735 63.3425Z",
  fill: "#C7F8FF"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6506 100.039C14.3759 100.039 14.9638 99.4506 14.9638 98.7253C14.9638 98.0001 14.3759 97.4121 13.6506 97.4121C12.9253 97.4121 12.3374 98.0001 12.3374 98.7253C12.3374 99.4506 12.9253 100.039 13.6506 100.039Z",
  fill: "#C7F8FF"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M155.76 167.296C156.486 167.296 157.074 166.708 157.074 165.983C157.074 165.257 156.486 164.669 155.76 164.669C155.035 164.669 154.447 165.257 154.447 165.983C154.447 166.708 155.035 167.296 155.76 167.296Z",
  fill: "#C7F8FF"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M107.823 77.9344L182.865 54.4648",
  stroke: "#85CAE4",
  strokeWidth: 9,
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M118.245 170.71L193.287 147.24",
  stroke: "#85CAE4",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M84.7109 152.042L104.934 216.714",
  stroke: "#85CAE4",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M35.082 167.327L55.3054 232",
  stroke: "#85CAE4",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9849 62.4282L51.2082 127.101",
  stroke: "#85CAE4",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M41.0918 94.4391L66.7781 86.4233C70.8153 85.1652 74.1886 82.3571 76.1581 78.6151C78.1276 74.8731 78.5324 70.5027 77.2837 66.4626L63.4793 22.3389",
  stroke: "#85CAE4",
  strokeWidth: 5.06,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M102.434 126.881L177.476 103.411",
  stroke: "#85CAE4",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M2.69336 144.562L109.746 111.08C111.204 110.623 112.42 109.607 113.129 108.254C113.839 106.9 113.982 105.321 113.528 103.863L82.6938 2",
  stroke: "#85CAE4",
  strokeWidth: 9,
  strokeMiterlimit: 10
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M2 174.282L106.489 141.609",
  stroke: "#85CAE4",
  strokeWidth: 9,
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M132.428 224.992L98.0742 115.146",
  stroke: "#85CAE4",
  strokeWidth: 9,
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M142.275 79.2826L119.277 86.5913L126.586 109.589L149.584 102.281L142.275 79.2826Z",
  fill: "#9FE0FA"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M97.9298 81.3553L75.0049 88.5947L82.2443 111.52L105.169 104.28L97.9298 81.3553Z",
  fill: "#9FE0FA"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M70.0503 90.5737L47.0522 97.8823L54.3609 120.88L77.359 113.572L70.0503 90.5737Z",
  fill: "#15A9E1"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M143.84 121.417L113.212 131.15L122.946 161.778L153.573 152.045L143.84 121.417Z",
  fill: "#15A9E1"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M179.685 110.506L149.058 120.239L158.791 150.867L189.419 141.133L179.685 110.506Z",
  fill: "#15A9E1"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M80.2257 159.706L42.79 171.603L54.6869 209.038L92.1226 197.141L80.2257 159.706Z",
  fill: "#15A9E1"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M172.588 69.7826L149.59 77.0913L156.899 100.089L179.897 92.7807L172.588 69.7826Z",
  fill: "#9FE0FA"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M123.116 87.3159C120.649 87.3194 118.219 87.9274 116.033 89.0882C113.846 90.2491 111.967 91.9287 110.555 93.9846C109.143 96.0405 108.239 98.4122 107.92 100.899C107.601 103.385 107.877 105.913 108.724 108.268C111.368 115.605 118.607 125.695 121.729 129.837C121.897 130.057 122.112 130.235 122.358 130.357C122.604 130.479 122.874 130.543 123.148 130.543C123.422 130.543 123.692 130.479 123.938 130.357C124.185 130.235 124.4 130.057 124.568 129.837C127.646 125.695 134.885 115.605 137.573 108.268C138.42 105.913 138.695 103.385 138.377 100.899C138.058 98.4122 137.154 96.0405 135.742 93.9846C134.33 91.9287 132.45 90.2491 130.264 89.0882C128.077 87.9274 125.648 87.3194 123.181 87.3159H123.116ZM123.116 107.144C122.305 107.149 121.511 106.908 120.834 106.453C120.158 105.999 119.629 105.35 119.316 104.589C119.002 103.829 118.918 102.991 119.074 102.182C119.229 101.373 119.618 100.628 120.19 100.044C120.762 99.4594 121.492 99.0606 122.287 98.8982C123.082 98.7357 123.907 98.8169 124.657 99.1314C125.407 99.4459 126.048 99.9796 126.499 100.665C126.95 101.35 127.191 102.156 127.191 102.98C127.163 104.062 126.722 105.09 125.961 105.846C125.2 106.603 124.18 107.029 123.116 107.034V107.144Z",
  fill: "#FF7171"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M127.13 137.368C127.13 138.269 126.862 139.151 126.361 139.899C125.86 140.648 125.147 141.232 124.314 141.575C123.48 141.918 122.564 142.007 121.68 141.828C120.797 141.65 119.986 141.213 119.351 140.574C118.716 139.934 118.285 139.12 118.113 138.236C117.941 137.351 118.036 136.435 118.386 135.604C118.735 134.773 119.323 134.065 120.076 133.569C120.828 133.073 121.711 132.812 122.613 132.818C123.814 132.827 124.963 133.31 125.809 134.162C126.655 135.015 127.13 136.167 127.13 137.368Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M122.58 139.643C123.836 139.643 124.855 138.624 124.855 137.368C124.855 136.111 123.836 135.093 122.58 135.093C121.323 135.093 120.305 136.111 120.305 137.368C120.305 138.624 121.323 139.643 122.58 139.643Z",
  fill: "#FF7171"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 233,
    viewBox: "0 0 195 233",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.eab961a4.svg";
export { ForwardRef as ReactComponent };